import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getStatusColor } from '../../data';
import type { DemoItem } from '@/types';
import './index.scss';

interface CardProps {
  demo: DemoItem;
  isActive?: boolean;
}

const Card: React.FC<CardProps> = ({ demo, isActive = false }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    if (demo.link) {
      navigate(demo.link);
    } 
  };

  const handleViewDemoClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (demo.link) {
      navigate(demo.link);
    } 
  };

  return (
    <div
      className={`demo-card ${isActive ? 'active' : ''}`}
      onClick={handleCardClick}
    >
      <div className="demo-preview">
        <div className="preview-placeholder">
          <div className="preview-animation">
            <div className="animation-line"></div>
            <div className="animation-line"></div>
            <div className="animation-line"></div>
          </div>
        </div>
      </div>

      <div className="demo-content">
        <div className="demo-title">
          <h3>{demo.name}</h3>
          <span
            className="status-badge"
            style={{ backgroundColor: getStatusColor(demo.status) }}
          >
            {demo.status}
          </span>
        </div>

        <p className="demo-description">{demo.description}</p>

        <div className="tech-tags">
          {demo.tech.map((tech, index) => (
            <span key={index} className="tech-tag">
              {tech}
            </span>
          ))}
        </div>

        <div className="demo-actions">
          <button className="view-demo-btn" onClick={handleViewDemoClick}>
            查看演示
          </button>
        </div>
      </div>
    </div>
  );
};

export default Card;
